import { Component, OnInit, ViewChild, ElementRef, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable } from 'rxjs';
import { BdGraph } from 'src/lib/graph/graph.model';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { TreeTheme } from 'src/app/shared/components/tree/tree/tree.component';
import { ViewMode } from '../../models/view-mode.enum';
import { ViewService } from '../../view.service';
import { TreeSearchDisplayMode } from 'src/app/shared/components/tree/tree-search/tree-search.component';
import { ViewState } from '../../state/view.state';
import { ViewActions } from '../../state/view.actions';

@Component({
  selector: 'app-view-search',
  templateUrl: './view-search.component.html',
  styleUrls: ['./view-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewSearchComponent implements OnInit {
  // ---------- View Children ----------
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef<HTMLInputElement>;
  


  // ---------- Observables ----------
  @Select(EngineState.getViewGraph)
  viewGraph$: Observable<BdGraph<ViewTreeNode>>;

  @Select(ViewState.getSearchDisplayMode)
  searchDisplayMode$: Observable<TreeSearchDisplayMode>;



  // ---------- Class Variables ----------
  query = '';
  treeTheme = TreeTheme;
  treeSearchDisplayMode = TreeSearchDisplayMode;

  constructor(
    private viewService: ViewService,
    private store: Store
    ) { }

  ngOnInit() {
  }

  // ---------- Interaction ----------

  handleSearchKeyup(event: KeyboardEvent, value: string) {
    if (event.key === 'Escape') {
      this.handleExitClick();
      this.searchInput.nativeElement.blur();
    }
    this.query = value;
  }

  handleExitClick() {
    this.query = '';
    this.viewService.toggleSearch(false);
  }

  toggleDisplayMode() {
    let displayMode = this.store.selectSnapshot(ViewState.getSearchDisplayMode);
    displayMode = (displayMode === TreeSearchDisplayMode.List) ? TreeSearchDisplayMode.Tree : TreeSearchDisplayMode.List;
    this.setDisplayMode(displayMode);
  }

  setDisplayMode(displayMode: TreeSearchDisplayMode) {
    this.store.dispatch(new ViewActions.SetSearchDisplayMode(displayMode));
  }
}
